import $ from 'jquery';

function scrollTop() {
	$( 'html,body' ).animate({ scrollTop: 0 }, 'slow' );
}

$( document ).ready( () => {
	$( '.scroll-top' ).click( e => {
		scrollTop();
		e.preventDefault();
	} )
} )
